import type { SortDirectionKey } from "./Sorting"
import type { SortComparator } from "./types"

/**
 * Compose comparators into one that applies them in order, falling through to
 * the next only on a tie.
 *
 * `"desc"` is implemented by swapping the pair before comparing, which
 * reverses whatever order the comparators define. That makes the comparators
 * you pass in the *ascending* definition of the sort — a comparator that
 * already orders descending would be flipped back by `"desc"` and end up
 * ascending. See `sortDeviceStatusByUrgencyAscending`.
 */
export function makePrioritySort<T extends object>(
  direction: SortDirectionKey,
  ...comparators: Array<SortComparator<T>>
): SortComparator<T> {
  return (a, b) => {
    let result = 0

    let left = a
    let right = b

    if (direction === "desc") {
      left = b
      right = a
    }
    // Apply the comparators in the order provided
    for (const comparator of comparators) {
      if (result === 0) {
        result = comparator(left, right)
      }
    }
    return result
  }
}
